import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MerchantService } from '../../../services/merchant.service';
import { Constants } from '../../../app.constants';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-automation-preview-dialog',
  templateUrl: './automation-preview-dialog.component.html',
  styleUrls: ['./automation-preview-dialog.component.css'],
})
export class AutomationPreviewDialogComponent implements OnInit {
  automation: any;
  customers: any[] = [];
  loading = false;
  totalCount = 0;
  pageSize = 50;
  pageIndex = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AutomationPreviewDialogComponent>,
    private merchantService: MerchantService,
    public constants: Constants,
  ) {
    this.automation = data.automation;
  }

  ngOnInit(): void {
    this.loadCustomers();
  }

  loadCustomers(): void {
    if (
      this.automation.trigger?.type &&
      this.automation.trigger.type !== 'schedule'
    ) {
      this.customers = [];
      this.totalCount = 0;
      return;
    }

    this.loading = true;

    // Build filters from automation target
    const filters = this.automation.target?.filters || {};
    
    // Extract card IDs
    const cardIds = this.automation.target?.cards?.map((c: any) =>
      typeof c === 'string' ? c : c._id,
    ) || [];
    
    // Extract voucher IDs
    const voucherIds = this.automation.target?.vouchers?.map((v: any) =>
      typeof v === 'string' ? v : v._id,
    ) || [];
    
    // Extract voucher status
    const voucherStatus = this.automation.target?.voucherStatus || [];

    this.merchantService
      .getCustomers(
        '_id',
        'desc',
        this.pageSize,
        this.pageIndex,
        '',
        filters,
        cardIds,
        voucherIds,
        voucherStatus,
      )
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.totalCount = res.totalDocs;
            this.customers = res.docs;
          }
        },
        error: (res: HttpErrorResponse) => {
          this.constants.snack(res.error.message);
        },
      })
      .add(() => (this.loading = false));
  }

  pageEvent(event: any): void {
    this.pageIndex = event.offset;
    this.loadCustomers();
  }

  close(): void {
    this.dialogRef.close();
  }

  getCustomerName(customer: any): string {
    return customer.user?.name || 'Unknown';
  }

  getCustomerEmail(customer: any): string {
    return customer.user?.email || '-';
  }
}
